import { reactQueryUtils } from "@lib/react-query";
import { useQuery } from "@tanstack/react-query";
import {
  handleCurrentUserResponse,
  transformUsersResponse,
  usersApi,
} from "./users.api";
import { usersKeys } from "./users.keys";
import type { TUser } from "./users.types";

export const useGetUsersQuery = (options = {}) => {
  return useQuery({
    queryKey: usersKeys.users,
    queryFn: async () => {
      const data = await usersApi.getUsers();
      return transformUsersResponse(data);
    },
    ...options,
  });
};

export const useLazyGetUsersQuery = () => {
  const query = async () => {
    const cache = reactQueryUtils.getQueryData<TUser[]>([...usersKeys.users]);
    if (cache) return cache;
    const data = await usersApi.getUsers();
    reactQueryUtils.setQueryData([...usersKeys.users], data);
    return transformUsersResponse(data);
  };
  return { query };
};

export const useGetUsersCountQuery = (skip?: boolean) => {
  return useQuery({
    queryKey: usersKeys.usersCount,
    queryFn: () => usersApi.getUsersCount(),
    enabled: !skip,
  });
};

export const useGetCurrentUserQuery = () => {
  return useQuery({
    queryKey: usersKeys.currentUser,
    queryFn: async () => {
      const data = await usersApi.getCurrentUser();
      return handleCurrentUserResponse(data);
    },
  });
};
